import AppButton from "../../UI/AppButtons";
import React, { useEffect, useRef, useState } from "react";
import BookingGetters from "../../../store/onlineBooking/getters";
import { Vehicle } from "../../../@types/DTO/Vehicles";
import { SelectedVehicleDetails } from "../../../@types/Booking/SelectedVehicleDetails";
import { BookingApi } from "../../../API/Apis/BookingApi";
import { useNavigate } from "react-router-dom";
import { PayPal } from "../PaymentForms/PayPal";
import AlertMessage from "../../../views/AlertMessage";
import { t } from "i18next";
import {
  getParentOrigin,
  allowedOrigins,
  blurScreen,
} from "../../../helpers/iframeSource";

function BookingSubmitFooter({
  selectedPaymentMethod,
  allPaymentMethods,
  isPaymentPage = "false",
}) {
  const paymentDetails =
    BookingGetters.getSelectedVehicleDetails()?.paymentDetails;
  const vehicleDetails =
    BookingGetters.getSelectedVehicleDetails()?.vehicleDetails;
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const ReservationDetails = BookingGetters.getBookingDetails();
  const payPalFormRef = useRef<HTMLFormElement>();
  const bookingInformation = BookingGetters.getBookingDetails();
  const [userId] = useState(localStorage.getItem("userID"));
  const attachedCustomer: string | undefined =
    localStorage.getItem("attachedCustomer") || undefined;
  const attachedDriver: string | undefined =
    localStorage.getItem("attachedDriver") || undefined;
  const driver2: string | undefined =
    localStorage.getItem("additionalDriver2") || undefined;
  const driver3: string | undefined =
    localStorage.getItem("additionalDriver3") || undefined;
  const isBlocklistCustomer = localStorage.getItem("isBlocklistCustomer");
  const onlineUserStatus = localStorage.getItem("onlineUserStatus");
  const isIphoneScreen = window.innerWidth >= 400 && window.innerWidth <= 768;
  const isAndroidScreen = window.innerWidth <= 400;
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const istabletScreen = window.innerWidth >= 768 && window.innerWidth <= 1220;
  const isSmallScreen = window.innerWidth <= 768;
  const isDesktopScreen = window.innerWidth >= 1310;
  useEffect(() => {
    if (isSaving) {
      blurScreen();
    } else {
      document.body.style.opacity = String(1);
      document.body.style.pointerEvents = "";
    }
  }, [isSaving]);
  const appSettings = BookingGetters.getAppSettings();
  const parentOrigin = getParentOrigin();
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };

  const scrollToBottom = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToBottom",
      },
      targetOrigin
    );
  };
  useEffect(() => {
    if (isPaymentPage === "true") {
      scrollToBottom();
    }
  }, [isPaymentPage]);

  const onRequestClose = () => {
    setOpenModal(false);
    setModalMessage("");
  };
  const [reservationId, setReservationId] = useState<number>(0);
  const navigateTo = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isBlocklistCustomer === "true") {
      setOpenModal(true);
      setModalMessage("Online user is blacklisted, we cannot create booking.");
      return;
    }
    if (onlineUserStatus === "BLOCKED" || onlineUserStatus === "DISABLED") {
      setOpenModal(true);
      setModalMessage(
        `Online user is ${onlineUserStatus}, we cannot create booking.`
      );
      return;
    }
    try {
      setIsSaving(true);
      const response = await BookingApi.createBooking(
        ReservationDetails,
        vehicleDetails as Vehicle,
        paymentDetails as SelectedVehicleDetails,
        selectedPaymentMethod,
        userId,
        attachedCustomer,
        attachedDriver,
        driver2,
        driver3,
        bookingInformation?.pickUpLocationDetails?.dealerId
      );
      if (response?.data.data?.dbId) {
        handleSuccessfulBooking(response?.data.data?.dbId);
      } else {
        setIsSaving(false);
        alert("Something went wrong. Booking not created. Please try again.");
      }
    } catch (error) {
      setIsSaving(false);
      console.error("Booking creation failed:", error);
      alert("An error occurred. Please try again.");
    }
  };
  // const handleSuccessfulBooking = async (dbId) => {
  //   setReservationId(dbId);
  //   setIsSaving(false);
  //   localStorage.setItem(
  //     dbId + ":vehicleImage",
  //     vehicleDetails?.Vehicle?.vehicleGroupPic || ""
  //   );
  //   localStorage.removeItem("attachedDriver2");
  //   localStorage.removeItem("attachedDriver3");
  //   localStorage.removeItem("attachedDriver");

  //   switch (selectedPaymentMethod.toLowerCase()) {
  //     case "paypal": {
  //       payPalFormRef?.current?.submit();
  //       break;
  //     }
  //     case "paypalcard":
  //       payPalFormRef?.current?.submit();
  //       break;
  //     case "nexi":
  //       handleNexiPayment(dbId);
  //       break;
  //     case "stripe":
  //       handleStripePayment(dbId);
  //       break;
  //     case "wiretransfer":
  //       handleWireTransfer(dbId);
  //       break;
  //     default:
  //       handleNexiPayment(dbId);
  //       break;
  //   }
  // };

  const handleSuccessfulBooking = async (dbId) => {
    setReservationId(dbId);
    setIsSaving(false);
    storeVehicleImage(dbId);
    clearAttachedDrivers();
    handlePaymentMethod(dbId);
  };

  const storeVehicleImage = (dbId) => {
    const image = vehicleDetails?.Vehicle?.vehicleGroupPic || "";
    localStorage.setItem(`${dbId}:vehicleImage`, image);
  };

  const clearAttachedDrivers = () => {
    ["attachedDriver", "attachedDriver2", "attachedDriver3"].forEach((key) =>
      localStorage.removeItem(key)
    );
  };

  const handlePaymentMethod = (dbId) => {
    const method = selectedPaymentMethod.toLowerCase();

    const paymentHandlers = {
      paypal: () => payPalFormRef?.current?.submit(),
      paypalcard: () => payPalFormRef?.current?.submit(),
      nexi: () => handleNexiPayment(dbId),
      stripe: () => handleStripePayment(dbId),
      wiretransfer: () => handleWireTransfer(dbId),
    };

    (paymentHandlers[method] || (() => handleNexiPayment(dbId)))();
  };

  const handleNexiPayment = async (dbId) => {
    const price =
      appSettings?.onrequestPayAmount &&
      vehicleDetails?.Status.toLowerCase() === "onrequest"
        ? 0.01
        : paymentDetails?.price || 0;
    const response = await BookingApi.getPaymentLink(dbId, price, "nexi");
    if (response.generateLink) {
      window.open(response.generateLink, "_self");
    }
  };
  const handleStripePayment = async (dbId) => {
    const response = await BookingApi.getPaymentLink(
      dbId,
      paymentDetails?.price || 0,
      "Stripe"
    );
    if (response.paymentUrl) {
      window.open(response.paymentUrl, "_self");
    }
  };
  const handleWireTransfer = (dbId) => {
    const trimmedDbId = dbId.split(" ").slice(0, 2).join(" ");
    BookingApi.sendEmailForWireTransfer(dbId, "false");
    navigateTo(`/booking/confirmed?dbId=${trimmedDbId}`);
  };
  return (
    <div
      className="bg-[#000000]"
      style={{
        height: "159px",
      }}
    >
      <span
        className={`md:flex-row md:float-left md:ml-[150px] md:mr-[125px] flex justify-between items-start ${
          isSmallScreen ? "sticky bottom-0" : ""
        }`}
        style={{
          fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
          fontSize: "20px",
          marginTop: isSmallScreen ? "10px" : "60px",
          marginLeft: isSmallScreen ? "10px" : "",
        }}
      >
        <span className="flex flex-col whitespace-nowrap">
          <span
            style={{
              fontSize: !isSmallScreen ? "24px" : "24px",
              marginLeft: isIphoneScreen ? "5%" : isAndroidScreen ? "10%" : "",
              marginTop: isSmallScreen ? "10px" : "",
            }}
          >
            {bookingInformation?.pickUpLocationDetails?.dealerName}
          </span>
          <span
            className="whitespace-nowrap"
            style={{
              fontSize: !isSmallScreen ? "24px" : "14px",
              marginLeft: isIphoneScreen ? "5%" : isAndroidScreen ? "10%" : "",
            }}
          >
            {bookingInformation?.pickUpLocationDetails?.locationDescription}
          </span>
        </span>
        {isSmallScreen == true && (
          <span className={`flex flex-col  ml-[25%] mt-[10px]`}>
            <span
              className="text-white"
              style={{
                fontFamily: "MBCorpoSText-Regular-Web-new",
                fontSize: "11px",
              }}
            >
              {t("Total Amount")}
            </span>
            <span
              className="md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
              style={{
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                fontSize: "32px",
                marginRight: "30px",
                color: "#0078D6",
                marginTop: "8px",
              }}
            >
              {(Math.round(paymentDetails?.price * 100) / 100).toFixed(2)}€
            </span>
            <br />
          </span>
        )}
      </span>

      <span
        className={`md:my-[10px] flex flex-col md:flex-row  ${
          isDesktopScreen ? "mr-[125px] float-right" : ""
        }`}
      >
        {(isDesktopScreen == true || istabletScreen == true) && (
          <span
            style={{
              color: "#FFFFFF",
              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
              fontSize: "48px",
              marginTop: !isSmallScreen ? "33px" : "",
            }}
            className="whitespace-nowrap"
          >
            {paymentDetails?.price.toFixed(2)}€<span>{" / "}</span>
            <span style={{ fontSize: "18px" }}>{t("Total")}</span>
          </span>
        )}
        <form
          onSubmit={handleSubmit}
          className="grow flex flex-col gap-16 p-4 mt-0 md:mt-[3%]"
        >
          <AppButton
            className={`w-full mb-2 ${isSmallScreen ? "z-50 mt-[-5%]" : ""}`}
            type="submit"
            style={{
              width: isSmallScreen ? "90vw" : "230.68px",
              maxWidth: "375px",
              fontFamily: "MBCorpoSText-Bold-Web-new",
            }}
            color="primary"
            onClick={() => {
              scrollToTop();
              window.scrollTo(0, 0);
            }}
          >
            <span
              style={{
                fontSize: "16px",
                marginTop: isSmallScreen ? "" : "19px",
                marginBottom: isSmallScreen ? "" : "19px",
                fontFamily: "MBCorpoSText-Bold-Web-new",
              }}
            >
              {t("Book Now")}
            </span>
          </AppButton>
        </form>
      </span>
      <AlertMessage
        openModal={openModal}
        requestOnClose={onRequestClose}
        modalMessage={modalMessage}
      />
      <div className={"text-black hidden"}>
        {allPaymentMethods?.paypal && allPaymentMethods?.paypal?.length > 0 && (
          <PayPal
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ref={payPalFormRef}
            postUrl={
              allPaymentMethods.paypal[0]?.developmentMode
                ? allPaymentMethods.paypal[0]?.sandboxPaymentURL || ""
                : allPaymentMethods.paypal[0]?.productionPaymentURL || ""
            }
            companyEmail={
              allPaymentMethods.paypal[0]?.developmentMode
                ? allPaymentMethods.paypal[0]?.sandboxEmailCompany || ""
                : allPaymentMethods.paypal[0]?.productionEmailCompany || ""
            }
            amount={paymentDetails?.price || 0}
            returnLink={
              allPaymentMethods.paypal[0]?.developmentMode
                ? allPaymentMethods.paypal[0]?.sandboxReturnURL || ""
                : allPaymentMethods.paypal[0]?.productionReturnURL || ""
            }
            notify_url={
              allPaymentMethods.paypal[0]?.developmentMode
                ? allPaymentMethods.paypal[0]?.sandboxNotifyURL || ""
                : allPaymentMethods.paypal[0]?.productionNotifyURL || ""
            }
            cancel_url={
              allPaymentMethods.paypal[0]?.developmentMode
                ? allPaymentMethods.paypal[0]?.sandboxCancelURL || ""
                : allPaymentMethods.paypal[0]?.productionCancelURL || ""
            }
            itemName={"NAME HERE"}
            reservationId={reservationId}
            openCard={selectedPaymentMethod == "paypalCard"}
            dealerId={Number(
              bookingInformation?.pickUpLocationDetails?.dealerId
            )}
            userId={Number(userId)}
          />
        )}
      </div>
    </div>
  );
}
export { BookingSubmitFooter };
